export class CustomMap {
    constructor(comparer) {
        this._map = new Map();
        this._comparer = comparer;
    }
    get size() {
        return this._map.size;
    }
    clear() {
        this._map.clear();
    }
    forEach(callbackfn) {
        this._map.forEach(callbackfn);
    }
    get(key) {
        let foundKey = undefined;
        for (const k of this._map.keys()) {
            if (this._comparer(k, key)) {
                foundKey = k;
                break;
            }
        }
        if (foundKey === undefined)
            return undefined;
        return this._map.get(foundKey);
    }
    set(key, value) {
        let foundKey = undefined;
        for (const k of this._map.keys()) {
            if (this._comparer(k, key)) {
                foundKey = k;
                break;
            }
        }
        if (foundKey === undefined)
            this._map.set(key, value);
        else
            this._map.set(foundKey, value);
    }
    delete(key) {
        let foundKey = undefined;
        for (const k of this._map.keys()) {
            if (this._comparer(k, key)) {
                foundKey = k;
                break;
            }
        }
        if (foundKey === undefined)
            return;
        this._map.delete(foundKey);
    }
    has(key) {
        for (const k of this._map.keys()) {
            if (this._comparer(k, key)) {
                return true;
            }
        }
        return false;
    }
}
